import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ParametroAwsSesModel } from '../model/parametros/parametro-aws-ses.model';

@Injectable({
  providedIn: 'root'
})
export class ParametroAwsSesService {
  private readonly http = inject(HttpClient);
  private readonly urlBase = `${environment.urlBase}/parametro-aws-ses`;

  buscar(): Observable<ParametroAwsSesModel> {
    return this.http.get<ParametroAwsSesModel>(this.urlBase);
  }

  salvar(parametroAwsSes: ParametroAwsSesModel): Observable<ParametroAwsSesModel> {
    return this.http.post<ParametroAwsSesModel>(this.urlBase, parametroAwsSes);
  }
}
